export const formStepActionsStyles = {
	root: {
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'flex-end',
		gap: 2,
		width: '100%'
	},
	footer: {
		display: 'flex',
		flexDirection: 'row',
		justifyContent: 'flex-end',
		alignItems: 'center',
		gap: 1,
		width: '100%'
	},
	actions: {
		display: 'flex',
		alignItems: 'flex-end',
		gap: 1
	},
	errorContainer: {
		width: '100%'
	},
	error: {
		width: 'fit-content',
		py: 0
	}
};
